module.exports = __webpack_public_path__ + "static/media/capture-video-web.0084f921.jpg";